var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-grm-comp": "RoomTestbankExamSubmitUserTable" } },
    [
      _c("div", { staticClass: "flex-col hidden lg:flex" }, [
        _c("table", [
          _c("colgroup", [
            _c("col", { attrs: { width: "2%" } }),
            _c("col", { attrs: { width: "10%" } }),
            _vm.testbankExamHistory.examType === "QUIZ"
              ? _c("col", { attrs: { width: "3%" } })
              : _vm._e(),
            _c("col", { attrs: { width: "10%" } }),
          ]),
          _c("thead", { staticClass: "h-8 bg-gray-200" }, [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("common.number")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("common.name")))]),
              _vm.testbankExamHistory.examType === "QUIZ"
                ? _c("th", [_vm._v(_vm._s(_vm.$t("testBank.score")))])
                : _vm._e(),
              _c("th", [_vm._v(_vm._s(_vm.$t("testBank.partiTime")))]),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "max-h-full overflow-y-auto scrollbar-hide" },
          [
            _c("table", [
              _c("colgroup", [
                _c("col", { attrs: { width: "2%" } }),
                _c("col", { attrs: { width: "10%" } }),
                _vm.testbankExamHistory.examType === "QUIZ"
                  ? _c("col", { attrs: { width: "3%" } })
                  : _vm._e(),
                _c("col", { attrs: { width: "10%" } }),
              ]),
              _c(
                "tbody",
                [
                  [
                    _vm._l(
                      _vm.testbankExamHistory.roomExamUserList,
                      function (user, i) {
                        return _c(
                          "tr",
                          {
                            key: user.userId,
                            staticClass:
                              "cursor-pointer transition hover:bg-gray-100",
                            on: {
                              click: function ($event) {
                                return _vm.onSelectUser(user)
                              },
                            },
                          },
                          [
                            _c("td", [_vm._v(_vm._s(i + 1))]),
                            _c("td", [_vm._v(_vm._s(user.username))]),
                            _vm.testbankExamHistory.examType === "QUIZ"
                              ? _c("td", [
                                  _vm._v(
                                    _vm._s(user.examScore) +
                                      _vm._s(_vm.$t("exam.question.point"))
                                  ),
                                ])
                              : _vm._e(),
                            _c("td", [
                              _vm._v(
                                _vm._s(user.beginDate) +
                                  " ~ " +
                                  _vm._s(user.endDate)
                              ),
                            ]),
                          ]
                        )
                      }
                    ),
                    !_vm.testbankExamHistory.roomExamUserList?.length
                      ? _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-center",
                              attrs: { colspan: "5" },
                            },
                            [_vm._v(_vm._s(_vm.$t("testBank.noSubmit")))]
                          ),
                        ])
                      : _vm._e(),
                  ],
                ],
                2
              ),
            ]),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "flex flex-col gap-2 lg:hidden" },
        _vm._l(_vm.testbankExamHistory.roomExamUserList, function (user, i) {
          return _c(
            "div",
            { key: user.userId, staticClass: "p-2 rounded bg-gray-100" },
            [
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("common.number"))),
                ]),
                _c("div", { staticClass: "min-w-0 flex-1 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(i + 1)),
                ]),
              ]),
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("common.name"))),
                ]),
                _c("div", { staticClass: "min-w-0 flex-1 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(user.username)),
                ]),
              ]),
              _vm.testbankExamHistory.examType === "QUIZ"
                ? _c("div", { staticClass: "flex" }, [
                    _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                      _vm._v(_vm._s(_vm.$t("testBank.score"))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "min-w-0 flex-1 py-2 px-3 text-sm" },
                      [
                        _vm._v(
                          _vm._s(user.examScore) +
                            _vm._s(_vm.$t("exam.question.point"))
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("testBank.partiTime"))),
                ]),
                _c("div", { staticClass: "min-w-0 flex-1 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(user.beginDate) + " ~ " + _vm._s(user.endDate)),
                ]),
              ]),
              _c("div", { staticClass: "py-2 px-3 flex justify-center" }, [
                _c(
                  "div",
                  { staticClass: "w-full flex gap-x-1" },
                  [
                    _c(
                      "GrmBtn",
                      {
                        staticClass: "flex-1",
                        on: {
                          click: function ($event) {
                            return _vm.onSelectUser(user)
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("setting.disclosure.password.see"))
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }